import { Skeleton } from '@mui/material';
import { colors } from '@client/new/components/colors';

export const ClipGalleryLoader = (p: { items?: number; width?: number }) => (
  <div className="flex flex-wrap gap-4">
    {Array(p.items || 3)
      .fill(0)
      .map((_, i) => (
        <Skeleton
          key={i}
          height={300}
          width={p.width ?? 400}
          sx={{ transform: 'scale(1)', backgroundColor: colors.secondary200 }}
        />
      ))}
  </div>
);
